module.exports = __webpack_public_path__ + "img/20241209_2.87291767.jpg";